export default {
  title: "SORU1",
  text: `Bir kitabım, okuyanı düşünmeye sevk etmezse, çabucak anlaşılırsa yazdıklarım kusurlu demektir. Okuyucular üslubumu basitleştirmemi isteseler de ben okuyucunun eserim üzerine kafa yormasını, gerekirse onu tekrar tekrar okumasını isterim. Eserlerimdeki yoğunluğun, anlam çeşitliliğinin nedeni budur. Bu yüzden eserlerimin çok satılmamasını hiç önemsemiyorum.`
};



// WEBPACK FOOTER //
// ./src/assets/goz-ritim/lgs/1.js